import { Component, inject, input } from '@angular/core';
import { ModalService } from '@shared/services';

@Component({
  selector: 'lib-refresh-now-app-banner',
  templateUrl: './refresh-now-app-banner.component.html',
  styleUrls: ['./refresh-now-app-banner.component.scss'],
})
export class RefreshNowAppBannerComponent {
  private readonly modalService = inject(ModalService);

  public readonly bannerText = input.required<string>();

  public refreshNow() {
    this.modalService
      .open({
        title: 'Confirm',
        message: 'Any unsaved work will be lost. Do you want to continue?',
        showButtons: true,
        sticky: true,
        okLabel: 'Refresh now',
        cancelLabel: 'Cancel',
      })
      .then(() => window.location.reload());
  }
}
